import {BaseContainerModel} from '../base-container.model';
import {AppletContainerModel} from '../applet';
import {bl_applet_catalog_hdr_RowClass} from '../../dbschema';

export class AppletStoreContainerModel extends BaseContainerModel {
  catalogHdr: bl_applet_catalog_hdr_RowClass = new bl_applet_catalog_hdr_RowClass();
  appletHeaderContainerList: AppletContainerModel[] = [];


}
